export const HOME_ROUTE = '/'
export const HOME_ALIASES = ['/home', '/login']
export const VERIFY_ROUTE = '/verifyuser/:verifyToken'
export const RESET_PASSWORD_ROUTE = '/resetpassword/:resetToken'
export const PRIVACY_POLICY_ROUTE = '/privacy'
export const TERMS_OF_SERVICE_ROUTE = '/terms'
export const PAGE_LOADER_PREVIEW_ROUTE = '/dev/page-loader'
export const RIVE_LOADER_PREVIEW_ROUTE = '/dev/rive-loader'
export const PROFILE_ROUTE = '/profile'
export const PROFILE_SETTINGS_ROUTE = '/profile/settings'
export const PROFILE_PERSONAL_DATA_ROUTE = '/profile/personal-data'
export const PROFILE_NOTIFICATIONS_ROUTE = '/profile/notifications'
export const PROFILE_NOTIFICATIONS_LIST_ROUTE = '/profile/notifications-list'
export const PROFILE_MY_PARAMETERS_ROUTE = '/profile/my-parameters'
export const PROFILE_SIZES_ROUTE = '/profile/sizes'
export const PROFILE_MY_STYLE_ROUTE = '/profile/my-style'
export const PROFILE_PEOPLE_ROUTE = '/profile/people'
export const FAVORITES_ROUTE = '/favorites'
export const LISTS_ROUTE = '/lists'
export const BRANDS_ROUTE = '/brands'
export const BRAND_DETAILS_ROUTE = '/brands/:brandName'
export const CAPSULE_ROUTE = '/capsule=:capsuleId(\\d+)'
export const PRODUCT_ROUTE = '/product=:productId(\\d+)/variant=:productVariantId(\\d+)'
export const PRODUCT_REVIEWS_ROUTE = '/product=:productId(\\d+)/variant=:productVariantId(\\d+)/reviews'
export const PRODUCT_REVIEW_IMAGE_ROUTE = '/product=:productId(\\d+)/variant=:productVariantId(\\d+)/review/:reviewId(\\d+)/image/:imageIndex(\\d+)?'
export const PRODUCT_OFFERS_ROUTE = '/product=:productId(\\d+)/variant=:productVariantId(\\d+)/offers'
export const PRODUCT_SIMILAR_ROUTE = '/product=:productId(\\d+)/variant=:productVariantId(\\d+)/similar'
export const SEARCH_ROUTE = '/searchList/:searchText?'
export const RECOMMENDATION_BANNERS_ROUTE = '/recommendations/banners/:bannerId(\\d+)'
export const RECOMMENDATION_COLLECTIONS_ROUTE = '/recommendations/collections/:collectionId(\\d+)'
export const STYLE_SPACE_ROUTE = '/style-space'
export const GIFT_IDEAS_ROUTE = '/gift-ideas'

export const ROUTE_PATHS = {
  home: HOME_ROUTE,
  profile: PROFILE_ROUTE,
  profileSettings: PROFILE_SETTINGS_ROUTE,
  profilePersonalData: PROFILE_PERSONAL_DATA_ROUTE,
  profileNotifications: PROFILE_NOTIFICATIONS_ROUTE,
  profileNotificationsList: PROFILE_NOTIFICATIONS_LIST_ROUTE,
  profileMyParameters: PROFILE_MY_PARAMETERS_ROUTE,
  profileSizes: PROFILE_SIZES_ROUTE,
  profileMyStyle: PROFILE_MY_STYLE_ROUTE,
  profilePeople: PROFILE_PEOPLE_ROUTE,
  favorites: FAVORITES_ROUTE,
  lists: LISTS_ROUTE,
  brands: BRANDS_ROUTE,
  brandDetails: BRAND_DETAILS_ROUTE,
  capsule: CAPSULE_ROUTE,
  product: PRODUCT_ROUTE,
  productReviews: PRODUCT_REVIEWS_ROUTE,
  productReviewImage: PRODUCT_REVIEW_IMAGE_ROUTE,
  productOffers: PRODUCT_OFFERS_ROUTE,
  productSimilar: PRODUCT_SIMILAR_ROUTE,
  search: SEARCH_ROUTE,
  recommendationsBanners: RECOMMENDATION_BANNERS_ROUTE,
  recommendationsCollections: RECOMMENDATION_COLLECTIONS_ROUTE,
  styleSpace: STYLE_SPACE_ROUTE,
  privacy: PRIVACY_POLICY_ROUTE,
  terms: TERMS_OF_SERVICE_ROUTE,
  verifyUser: VERIFY_ROUTE,
  resetPassword: RESET_PASSWORD_ROUTE
} as const

export default ROUTE_PATHS
